import React, {PureComponent} from "react"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {}

class IDPLoginError extends PureComponent<Props> {
  render() {
    const {formatMessage} = this.props

    const link = (
      <RouterLink to="/welcome/login">
        {formatMessage({id: "platform.login.idp.error.link.text"})}
      </RouterLink>
    )

    return (
      <FormattedMessage id="platform.login.idp.error.message" values={{link}} />
    )
  }
}

export default injectIntl(IDPLoginError)
